import React, { useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function SubscribeDialog(props) {

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      props.onSubscription();
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogContent>
        <p>{TR.cm_invalid_subscription} {props.failureMsg ? props.failureMsg : ""}</p>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_close}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onSubscription()}>{TR.cm_subscribe_now}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default SubscribeDialog;